import { render, staticRenderFns } from "./myRecycling.vue?vue&type=template&id=22b1e381&scoped=true"
import script from "./myRecycling.vue?vue&type=script&lang=js"
export * from "./myRecycling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1e381",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22b1e381')) {
      api.createRecord('22b1e381', component.options)
    } else {
      api.reload('22b1e381', component.options)
    }
    module.hot.accept("./myRecycling.vue?vue&type=template&id=22b1e381&scoped=true", function () {
      api.rerender('22b1e381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/myRecycling.vue"
export default component.exports